import { getStoreId } from "$/hooks/use-store-information.ts"
import statsQueries, { StatsFilterArgs } from "$/lib/queries/stats-queries.ts"
import { requireStoreFeature } from "$/lib/require-store-feature.ts"
import { toTrendSelection } from "$/routes/(app)/_auth/statistik/-utils/to-trend-selection"
import { STORE_FEATURE } from "@repo/common"
import {
  TREND_PERIODS,
  getTrendRequest,
} from "@repo/ui/hooks/use-trend-controls"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

/** In the URL so the period survives the reload a store switch causes. */
const searchSchema = z.object({
  period: z.enum(TREND_PERIODS).optional().catch(undefined),
  from: z.string().datetime().optional().catch(undefined),
  to: z.string().datetime().optional().catch(undefined),
})

/** What the page opens with, before anything is filtered. */
const DEFAULT_FILTER: StatsFilterArgs = {
  labelIds: [],
  labelFilterMode: "include",
  includeZeroValueJobs: false,
}

export const Route = createFileRoute("/(app)/_auth/statistik/")({
  validateSearch: searchSchema,
  loaderDeps: ({ search: { period, from, to } }) => ({ period, from, to }),
  loader: async ({ context: { queryClient }, deps: { period, from, to } }) => {
    await requireStoreFeature(queryClient, STORE_FEATURE.INSIGHTS)
    const storeId = await getStoreId()
    if (storeId) {
      const { dateRange, timeUnit, spanParams, endDate } = getTrendRequest(
        toTrendSelection(period, from, to),
      )

      queryClient.prefetchQuery(
        statsQueries.allStats(
          storeId,
          dateRange.from,
          dateRange.to,
          DEFAULT_FILTER,
        ),
      )
      queryClient.prefetchQuery(
        statsQueries.allTrends(
          storeId,
          timeUnit,
          spanParams,
          endDate,
          DEFAULT_FILTER,
        ),
      )
      queryClient.prefetchQuery(
        statsQueries.leadTimeStandings(
          storeId,
          dateRange.from,
          dateRange.to,
          DEFAULT_FILTER,
        ),
      )
    }

    return {
      crumb: "alfred.pages.statistics.crumbs.statistics",
    }
  },
})
